<ng-container *ngrxLet="firmwareUpdateStore.versionListParams$ as versionList">
  <ng-container *ngrxLet="firmwareUpdateStore.xota2OperationProcess$ as xotaUpdateOperation">
    <ng-container *ngrxLet="firmwareUpdateStore.bundleUpdateStep$ as bundleUpdateStep">
      <mat-card data-at-firmware-update-modal>
        <mat-card-header>
          <mat-card-title>
            {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.TITLE' | translate }}
          </mat-card-title>
        </mat-card-header>
        <ng-container
          *ngIf="
            !versionList.isLoading && bundleUpdateStep === XotaBundleUpdateStep.CHECK_FOR_UPDATE
          "
        >
          <p class="mb-4">
            {{
              '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_UPDATE_MODAL.DESCRIPTION'
                | translate
            }}
          </p>
          <a
            data-at-release-notes
            class="font-semibold mb-4"
            gtm="onGoToPage"
            gtmAction="Release notes"
            gtmCategory="firmwareUpdate"
            rel="noreferrer"
            href="https://climate-solutions.com/documents/6226921"
            target="_blank"
            >{{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.RELEASE_NOTES' | translate }}</a
          >
        </ng-container>
        <mat-card-content>
          <ng-container
            *ngIf="
              (firmwareUpdateStore.isLoading$ | async) &&
              (firmwareUpdateStore.overallProgress$ | async)
            "
          >
            <div>
              <vi-progress-bar-determine
                [value]="versionList.overallProgress"
                [isLoading]="versionList.isLoading"
                *ngIf="versionList.isLoading"
                class="mb-4"
              ></vi-progress-bar-determine>
              <p class="mb-2 mt-2">
                {{ 'FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.UPDATE_IN_PROGRESS' | translate }}
                ({{ versionList.overallProgress }}%)
              </p>
            </div>
          </ng-container>
          <div class="mb-4">
            <app-firmware-update-version-list-banner
              [versionList]="versionList"
            ></app-firmware-update-version-list-banner>
          </div>
          <ng-container [ngSwitch]="firmwareUpdateStore.bundleUpdateStep$ | async">
            <ng-container *ngSwitchCase="XotaBundleUpdateStep.CHECK_FOR_UPDATE">
              <app-firmware-update-version-list-check
                [versionList]="versionList"
                [xotaUpdateOperation]="xotaUpdateOperation"
              ></app-firmware-update-version-list-check>
            </ng-container>
            <ng-container *ngSwitchCase="XotaBundleUpdateStep.UPDATING">
              <app-firmware-update-version-list-updating
                [versionList]="versionList"
                [xotaUpdateOperation]="xotaUpdateOperation"
              ></app-firmware-update-version-list-updating>
            </ng-container>
            <ng-container *ngSwitchCase="XotaBundleUpdateStep.FINALIZE">
              <app-firmware-update-version-list-finalize
                [versionList]="versionList"
                [xotaUpdateOperation]="xotaUpdateOperation"
              ></app-firmware-update-version-list-finalize>
            </ng-container>
          </ng-container>
        </mat-card-content>
        <mat-card-actions class="!flex flex-row lt-md:flex-col gap-3 justify-end items-center">
          <ng-container *ngrxLet="firmwareUpdateStore.isUpdateAvailable$ as isUpdateAvailable">
            <ng-container *ngrxLet="firmwareUpdateStore.bundleUpdateStep$ as bundleUpdateStep">
              <button
                *ngIf="bundleUpdateStep !== XotaBundleUpdateStep.UPDATING"
                mat-raised-button
                color="primary"
                class="fill-btn lt-md:order-2"
                gtm="onCancelDialog"
                gtmCategory="firmwareUpdate"
                gtmAction="Close firmware update modal"
                data-at-firmware-update-modal-close
                (click)="onCancel()"
              >
                {{ 'GENERAL.BUTTON.CLOSE' | translate }}
              </button>

              <button
                *ngIf="
                  bundleUpdateStep !== XotaBundleUpdateStep.FINALIZE &&
                  !(versionList.status === BundleUpdateStatus.Failed) &&
                  (!versionList.missingBusTopology?.othersEcusMissingInBusTopology ||
                    isUpdateAvailable)
                "
                mat-raised-button
                color="primary"
                class="connection-button fill-btn !flex flex-row justify-center items-center lt-md:order-1"
                gtm="onNextStep"
                gtmCategory="firmwareUpdate"
                gtmAction="Check firmware update availability"
                data-at-firmware-update-modal-next
                (click)="updateFirmware()"
                [disabled]="versionList.isLoading"
              >
                <ng-container *ngIf="!versionList.isLoading; else updating">
                  <div class="flex items-center">
                    <span>{{ 'GENERAL.BUTTON.UPDATE' | translate }}</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </div>
                </ng-container>
                <ng-template #updating>
                  <span>
                    {{
                      '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.UPDATING'
                        | translate
                    }}
                  </span>
                </ng-template>
              </button>
            </ng-container>
          </ng-container>
        </mat-card-actions>
      </mat-card>
    </ng-container>
  </ng-container>
</ng-container>
